import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DepositWithdrawCounts } from '@/store/api/bankerApi';

const initialState: DepositWithdrawCounts = {
  pendingDepositCount: 0,
  pendingWithdrawCount: 0,
  totalPendingCount: 0,
};

const depositWithdrawCountsSlice = createSlice({
  name: 'depositWithdrawCounts',
  initialState,
  reducers: {
    setDepositWithdrawCounts: (_state, action: PayloadAction<DepositWithdrawCounts>) =>
      action.payload,
    clearDepositWithdrawCounts: () => initialState,
  },
});

export const { setDepositWithdrawCounts, clearDepositWithdrawCounts } =
  depositWithdrawCountsSlice.actions;
export const depositWithdrawCountsReducer = depositWithdrawCountsSlice.reducer;
